import type { PopWhatsIncludedItemData } from '@/app/[locale]/product/rings/_types';

import PopWhatsIncludedItem from './PopWhatsIncludedItem';

export interface PopWhatsIncludedProps {
  readonly items: PopWhatsIncludedItemData[];
}

const PopWhatsIncluded = ({ items }: PopWhatsIncludedProps): JSX.Element => {
  return (
    <section>
      {items.map((item, i) => (
        <PopWhatsIncludedItem {...item} index={i} key={item.title} />
      ))}
    </section>
  );
};

export default PopWhatsIncluded;
